import { ERROR_ACTION, WAIT_FOR_ACTION } from "redux-wait-for-action";

export const actionTypes = {
    ALT_ASSET_ITEM_CLEAR: "ALT_ASSET_ITEM_CLEAR",
    ALT_ASSET_ITEM_SET: "ALT_ASSET_ITEM_SET",
    ALT_ASSET_ITEM_UPDATE: "ALT_ASSET_ITEM_UPDATE",

    ALT_ASSET_PATCH_FAILURE: "ALT_ASSET_PATCH_FAILURE",
    ALT_ASSET_PATCH_REQUEST: "ALT_ASSET_PATCH_REQUEST",
    ALT_ASSET_PATCH_SUCCESS: "ALT_ASSET_PATCH_SUCCESS",

    ALT_ASSETS_BULK_UPDATE_POST_FAILURE: "ALT_ASSETS_BULK_UPDATE_POST_FAILURE",
    ALT_ASSETS_BULK_UPDATE_POST_REQUEST: "ALT_ASSETS_BULK_UPDATE_POST_REQUEST",
    ALT_ASSETS_BULK_UPDATE_POST_SUCCESS: "ALT_ASSETS_BULK_UPDATE_POST_SUCCESS",

    ALT_ASSETS_CLEAR: "ALT_ASSETS_CLEAR",

    ALT_ASSETS_GET_FAILURE: "ALT_ASSETS_GET_FAILURE",
    ALT_ASSETS_GET_REQUEST: "ALT_ASSETS_GET_REQUEST",
    ALT_ASSETS_GET_SUCCESS: "ALT_ASSETS_GET_SUCCESS",

    ALT_ASSET_GET_BY_ID_FAILURE: "ALT_ASSET_GET_BY_ID_FAILURE",
    ALT_ASSET_GET_BY_ID_REQUEST: "ALT_ASSET_GET_BY_ID_REQUEST",
    ALT_ASSET_GET_BY_ID_SUCCESS: "ALT_ASSET_GET_BY_ID_SUCCESS",

    ALT_ASSET_UPDATE_STORE: "ALT_ASSET_UPDATE_STORE",
    ALT_ASSETS_MERGE: "ALT_ASSETS_MERGE",
    ALT_ASSETS_SET: "ALT_ASSETS_SET"
};

export const actionCreators = {
    bulkUpdatePostRequest: (altAssets: Array<any>) => ({
        type: actionTypes.ALT_ASSETS_BULK_UPDATE_POST_REQUEST,
        payload: { altAssets },
        [WAIT_FOR_ACTION]: actionTypes.ALT_ASSETS_BULK_UPDATE_POST_SUCCESS,
        [ERROR_ACTION]: actionTypes.ALT_ASSETS_BULK_UPDATE_POST_FAILURE
    }),
    bulkUpdatePostSuccess: (altAssets: Array<any>) => ({
        type: actionTypes.ALT_ASSETS_BULK_UPDATE_POST_SUCCESS,
        payload: { altAssets }
    }),
    bulkUpdatePostFailure: (error) => ({
        type: actionTypes.ALT_ASSETS_BULK_UPDATE_POST_FAILURE,
        error
    }),

    clear: () => ({
        type: actionTypes.ALT_ASSETS_CLEAR
    }),

    getRequest: (auditId: number) => ({
        type: actionTypes.ALT_ASSETS_GET_REQUEST,
        payload: { auditId },
        [WAIT_FOR_ACTION]: actionTypes.ALT_ASSETS_GET_SUCCESS,
        [ERROR_ACTION]: actionTypes.ALT_ASSETS_GET_FAILURE
    }),
    getSuccess: (altAssets: Array<any>) => ({
        type: actionTypes.ALT_ASSETS_GET_SUCCESS,
        payload: { altAssets }
    }),
    getFailure: (error) => ({
        type: actionTypes.ALT_ASSETS_GET_FAILURE,
        error
    }),

    getByIdRequest: (altAssetId: number, auditId: number) => ({
        type: actionTypes.ALT_ASSET_GET_BY_ID_REQUEST,
        payload: { altAssetId, auditId },
        [WAIT_FOR_ACTION]: actionTypes.ALT_ASSET_GET_BY_ID_SUCCESS,
        [ERROR_ACTION]: actionTypes.ALT_ASSET_GET_BY_ID_FAILURE
    }),
    getByIdSuccess: (altAsset: any) => ({
        type: actionTypes.ALT_ASSET_GET_BY_ID_SUCCESS,
        payload: { altAsset }
    }),
    getByIdFailure: (error) => ({
        type: actionTypes.ALT_ASSET_GET_BY_ID_FAILURE,
        error
    }),

    itemClear: () => ({
        type: actionTypes.ALT_ASSET_ITEM_CLEAR
    }),
    itemSet: (altAsset: any) => ({
        type: actionTypes.ALT_ASSET_ITEM_SET,
        payload: { altAsset }
    }),
    itemUpdate: (altAsset: any) => ({
        type: actionTypes.ALT_ASSET_ITEM_UPDATE,
        payload: { altAsset }
    }),

    patchRequest: (altAsset: any) => ({
        type: actionTypes.ALT_ASSET_PATCH_REQUEST,
        payload: { altAsset },
        [WAIT_FOR_ACTION]: actionTypes.ALT_ASSET_PATCH_SUCCESS,
        [ERROR_ACTION]: actionTypes.ALT_ASSET_PATCH_FAILURE
    }),
    patchSuccess: (altAsset: Array<any>) => ({
        type: actionTypes.ALT_ASSET_PATCH_SUCCESS,
        payload: { altAsset }
    }),
    patchFailure: (error) => ({
        type: actionTypes.ALT_ASSET_PATCH_FAILURE,
        error
    }),

    updateStore: (altAsset: any) => ({
        type: actionTypes.ALT_ASSET_UPDATE_STORE,
        payload: { altAsset }
    }),

    set: (altAssets: Array<any>) => ({
        type: actionTypes.ALT_ASSETS_SET,
        payload: { altAssets }
    }),
    merge: (altAssets: Array<any>) => ({
        type: actionTypes.ALT_ASSETS_MERGE,
        payload: { altAssets }
    })
};

export default {
    create: actionCreators,
    type: actionTypes
};
